import { createI18n } from "vue-i18n";
// import translations
import ru from "../assets/na-lang-ru.json";
import en from "../assets/na-lang-en.json";
import vi from "../assets/na-lang-vi.json";

// Русское правило выбора формы: 1 файл / 2 файла / 5 файлов.
// choicesLength — страховка на случай, если в переводе меньше трёх ветвей.
const ruPluralRule = (choice: number, choicesLength: number): number => {
    const n = Math.abs(choice);
    const mod10 = n % 10;
    const mod100 = n % 100;
    let index: number;
    if (mod100 >= 11 && mod100 <= 19) {
        index = 2;
    } else if (mod10 === 1) {
        index = 0;
    } else if (mod10 >= 2 && mod10 <= 4) {
        index = 1;
    } else {
        index = 2;
    }
    return Math.min(index, choicesLength - 1);
};

// configure i18n
export const i18n = createI18n({
    locale: "en",
    fallbackLocale: "en",
    messages: { ru, en, vi },
    pluralizationRules: { ru: ruPluralRule },
});

/**
 * Плюрализация вне шаблона.
 *
 * Две проверенные ловушки vue-i18n 9.14.4 в legacy-режиме, из-за которых
 * этот хелпер и существует:
 *
 * 1. Число понимает ТОЛЬКО tc(). Вызов t('key', 5) на ключе с "|" не падает,
 *    а молча возвращает первую ветвь с пустым {n} ("Прикреплено  файл").
 *
 * 2. Если в tc() передать НЕПУСТОЙ объект named, выбор формы ломается: она
 *    схлопывается в единственное число независимо от count ("Прикреплено 1 файл"
 *    при пяти файлах). Лечится тем, что n и count подставляются в named явно —
 *    поэтому здесь всегда собирается новый объект с n/count внутри.
 */
export const tp = (key: string, count: number, named: Record<string, unknown> = {}): string => {
    return String(i18n.global.tc(key, count, { ...named, n: count, count }));
};